// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._11c8nbxd{font:var(--ds-font-heading-small,normal 600 1pc/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._zulppxbi{gap:var(--ds-space-200,1pc)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._10fp1h6o{justify-self:center}\n._1e0c11p5{display:grid}\n._1wpz1h6o{align-self:center}\n._4cvr1h6o{align-items:center}\n._6a6z1h6o{justify-items:center}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
